module.exports = __webpack_public_path__ + "static/media/circle-icon.75f5e96e.svg";